<template>
  <a-config-provider :locale="locale">
    <div id="app">
      <router-view />
    </div>
  </a-config-provider>
</template>

<script>
import zhCN from "ant-design-vue/lib/locale-provider/zh_CN";
export default {
  name: "App",
  return() {
    return {};
  },
  created() {
    console.log(this.locale);
  },
  computed: {
    locale() {
      return zhCN;
    },
  },
  components: {},
};
</script>

<style>
#app {
  font-family: "微软雅黑";
}

* {
  margin: 0;
  padding: 0;
}
</style>
